import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Flex,
  HStack,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Portal,
  Text,
  Tooltip,
  Box,
} from "@chakra-ui/react";
import { FaChevronDown } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useRefreshRoundList, useSelectRound } from "../../QuestionnaireRound/RoundService";
import { useNavigate } from "react-router-dom";
import { EyeClosed, Lock, Plus } from "@phosphor-icons/react";
import { routes } from "../../../../config";
import useAirUserRoles from "../../../../utils/AuthUtils";

const RoundList = ({ variant = "outline" }) => {
  const { refreshRoundList } = useRefreshRoundList();
  const navigate = useNavigate();
  const selectRound = useSelectRound();
  const roundSelector = useSelector((state) => state.issbRound);
  const [hasOverflow, setHasOverflow] = useState(false);
  const menuListRef = useRef(null);

  const { isOrgAdmin } = useAirUserRoles();

  useEffect(() => {
    refreshRoundList();
  }, [refreshRoundList]);

  useEffect(() => {
    if (roundSelector?.roundList.length === 1 && !roundSelector?.selectedRound) {
      selectRound(roundSelector.roundList[0]);
    }
  }, [roundSelector?.roundList, selectRound, roundSelector?.selectedRound]);

  useEffect(() => {
    const menuList = menuListRef.current;
    if (menuList) {
      setHasOverflow(menuList.scrollHeight > menuList.clientHeight);
    }
  }, [roundSelector?.roundList]);

  const handleSelect = (round) => {
    selectRound(round);
  };

  const handleStartRound = () => {
    navigate(routes.issbQuestionnaireRoundSetup);
  };

  return (
    <Menu>
      <MenuButton
	    id="round-list-open-menu-button"
        fontSize="14px" // TODO: temp fix with fixed font size, chakra theme value is not working here
        as={Button}
        variant={variant}
        rightIcon={<FaChevronDown />}
      >
        <HStack>
          <Text display={{ base: "none", lg: "block" }}>{roundSelector?.selectedRound?.name || "Select round"}</Text>
        </HStack>
      </MenuButton>
      <Portal>
        <MenuList maxHeight="250px" overflowY="auto" ref={menuListRef} zIndex={9999}>
          {isOrgAdmin && (
            <>
              <MenuItem icon={<Plus size={18} />} onClick={handleStartRound}>
                Create a new round
              </MenuItem>
              <MenuDivider />
            </>
          )}

          {/* <EyeClosed draft, */}
          {roundSelector?.roundList.map((round) => (
            <MenuItem key={round.id} onClick={() => handleSelect(round)} className="round-list-item">
              <Flex justifyContent="space-between" alignItems="center" width="100%">
                <Text>{round.name}</Text>
                {round.state === "CLOSED" && (
                  <Box title="This round is Closed and should not be edited">
                    <Lock size={18} />
                  </Box>
                )}
                {round.state === "DRAFT" && (
                  <Box title="Draft - Start the round to let other users access it">
                    <EyeClosed size={18} />
                  </Box>
                )}
              </Flex>
            </MenuItem>
          ))}
          {hasOverflow && (
            <div
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                height: "20px",
                background: "linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))",
              }}
            />
          )}
        </MenuList>
      </Portal>
    </Menu>
  );
};

export default RoundList;
